import { createSelector, createStructuredSelector } from 'reselect';
import { initialState } from './reducer';
import { RootState } from '../../interface';
import { NameSpace } from '../../enum';

/**
 * Selects the container's state from RootState based on the given namespace
 * @param {RootState} state - rootstate of the app
 * @returns {LeadManagementState} - the App container's state
 */
export const selectState = (state: RootState) => state[NameSpace.LEAD_MANAGEMENT] || initialState;

export const selectError = createSelector(selectState, state => state.error);
export const selectForm = createSelector(selectState, state => state.form);
export const selectResult = createSelector(selectState, state => state.result);

/**
 * Create a structured selector. (Map our selectors into specific keys in an object)
 * Used to connect the state to the container
 */
export const mapStateToProps = createStructuredSelector({
    form: selectForm,
    result: selectResult,
    error: selectError,
});
